// @flow
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { animated } from 'react-spring/web.cjs';
import { SPACING } from '@tablekit/theme';
import {
  CoreTestimonialCard,
  SMALL_SCREEN_HEIGHT,
  LARGE_SCREEN_HEIGHT,
  LARGE_SCREEN_WIDTH
} from './static';

const baseStyles = css`
  position: absolute;
  padding: ${SPACING.L6};
  top: 50%;
  left: 0;
`;

export const AnimatedTestimonialCard = animated(styled(CoreTestimonialCard)`
  ${baseStyles};
`);

export const CARD_DISPLAYS = [
  {
    minWidth: 0,
    displayCount: 1,
    height: SMALL_SCREEN_HEIGHT,
    gutter: parseInt(SPACING.L2, 10)
  },
  {
    minWidth: LARGE_SCREEN_WIDTH,
    displayCount: 2,
    height: LARGE_SCREEN_HEIGHT,
    gutter: parseInt(SPACING.L4, 10)
  }
];
